module.exports = __webpack_public_path__ + "img/Combined_Shape@1x.f8ebd63b.svg";